import WaitingDots from 'components/WaitingDots';
import {Expense} from 'models/Expense';
import React from 'react';
import {Link} from 'react-router-dom';
import {useOfficeTranslation} from 'i18n/OfficeTranslation';
import {connect} from 'react-redux';
import {RootState} from 'store/store';
import {AccountState} from 'store/reducers/Accounts';

interface Props {
    accountState: AccountState;
    expense: Expense;
    expenseId: string;
}

const ExpenseRowAccount: React.FC<Props> = ({ accountState, expense, expenseId }) => {
    const {intlLocale, t} = useOfficeTranslation();
    if (expense === undefined) return <WaitingDots />;

    return <tr key={expense.id}>
        <td>{expense.id === expenseId && <span className='badge bg-primary'>{t("expenses.expenseRowSupplier.currentExpense")}</span>}<Link to={`/accounts/${expense.account_id}`}><span style={{display: 'block', width: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{accountState.getAccountById(expense.account_id)?.legal_name ?? t("common.unknownSupplier")}</span></Link></td>
        <td><Link to={`/expenses/${expense.id}`}><span style={{display: 'block', width: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{expense.name !== "" ? expense.name : <i>{t("common.noName")}</i>}</span></Link></td>
        <td>{new Intl.DateTimeFormat(intlLocale, {dateStyle: "medium"}).format(expense.GetDate())}</td>
        <td>{new Intl.NumberFormat(intlLocale, {style: "currency", currency: "EUR"}).format(expense.total)}</td>
    </tr>;
};

const mapStateToProps = (state: RootState) => ({accountState: state.Accounts});

export default connect(mapStateToProps)(ExpenseRowAccount);
